import dayjs from 'dayjs';

/**
 * Gets a comparator function.
 * @param property The property to compare
 * @param direction The direction to sort (asc = 1, desc = -1)
 * @returns {function(property, other): number}
 */
const sortComparator = (property, direction) => {
  return (a, b) => {
    let operand1 = a[property];
    let operand2 = b[property];
    if (operand1 === null) {
      operand1 = '';
    }
    if (operand2 === null) {
      operand2 = '';
    }
    if (typeof operand1 === 'string') {
      operand1 = operand1.toLowerCase();
    }
    if (typeof operand2 === 'string') {
      operand2 = operand2.toLowerCase();
    }
    if (operand1 === operand2) {
      return 0;
    }
    return (operand1 < operand2) ? direction * -1 : direction;
  };
};

const matchFilter = (filter, element, filterFields, languageCode, dateFormatter) => {
  for (let field of filterFields) {
    let fieldValue = element[field];
    if (languageCode && element[field] instanceof Date) {
      fieldValue = dayjs(element[field]).locale(languageCode).format(dateFormatter);
    }

    if (!filter || (fieldValue && fieldValue.toString().toLowerCase().includes(filter.toString().toLowerCase()))) {
      return true;
    }
  }
  return false;
};

const createPage = (data, state, filterFields, pageSize, { page, filter, sort }, locale = undefined, dateFormatter = 'D MMMM YYYY, HH:mm') => {
  // If the filter or the sort params change, reset the page.
  if (filter !== state.filter ||
      sort.fieldName !== state.sort.fieldName ||
      sort.order !== state.sort.order) {
    page = 1;
  }
  const newState = {
    filter: filter,
    page: page,
    sort: {
      fieldName: sort.fieldName,
      order: sort.order
    }
  };

  const direction = sort.order === 'asc' ? 1 : -1;
  const filteredAndSortedData = data
    .filter(element => matchFilter(filter, element, filterFields, locale, dateFormatter))
    .sort(sortComparator(sort.fieldName, direction));

  const count = filteredAndSortedData.length;

  const totalPages = count % pageSize > 0 ? Math.floor(count / pageSize) + 1 : Math.floor(count / pageSize);
  const currentPage = totalPages < page ? totalPages : page;

  const content = filteredAndSortedData.slice((currentPage - 1) * pageSize, (currentPage) * pageSize);
  return {
    state: newState,
    result: {
      data: content,
      pagination: {
        totalPages: totalPages,
        currentPage: currentPage,
        count: count
      },
      filteredAndSortedData: filteredAndSortedData
    }
  };
};

export default {
  createPage
};



// WEBPACK FOOTER //
// ./src/components/shared/table/pagination.js